import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#F2EADF',
        secondary: '#611230',
        accent: '#B48E5D',
        error: '#FF9078',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        surface: '#F2EADF',
        anchor: '#00003c',
        eon: '#f68632',
      },
      dark: {
        primary: '#00003c',
        secondary: '#bbdefb',
        accent: '#1a05a3',
        error: '#B00020',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        eon: '#f68632',
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons: {
    iconfont: 'mdi',
  },
});
